import React from "react";
import { Popup } from "../../../../Types";
import { UseDownloadAsset } from "../../../../api/calls/Queries";
import { useViewerPopupStore } from "../../../../state management/zustand/viewer-stores";
import { getLanguageFile } from "../../../common/GetLanguageFile";

const OpenImagePopup = () => {
  const { currentPopupContent } = useViewerPopupStore();
  const currentPop = currentPopupContent as Popup;

  const { data: imageUrl } = UseDownloadAsset(currentPop?.image!);

  const [vertical, setVertical] = React.useState<boolean>();

  const [isLoadingImg, setIsLoading] = React.useState<boolean>();

  React.useEffect(() => {
    setIsLoading(true);
    if (imageUrl) {
      let img = new Image();
      img.src = imageUrl;

      img.onload = () => {
        const ratio = img.naturalWidth / img.naturalHeight;
        const vert = ratio >= 1;

        setVertical(vert);

        setIsLoading(false);
        //@ts-expect-error
        img = null;
      };
    }
  }, [imageUrl]);

  if (isLoadingImg) return <LoadingScreen></LoadingScreen>;
  else
    return (
      <div
        className={`image-pop ${vertical ? "vertical" : "horizontal"}`}
        style={
          {
            // minWidth: 0,
            // height: "600px",
            // display: "flex",
          }
        }
      >
        <div className="image">
          <img src={imageUrl} alt={imageUrl}></img>
        </div>

        {currentPop.text && <div className="text">{currentPop.text}</div>}
      </div>
    );
};

export default OpenImagePopup;

const LoadingScreen = () => {
  return (
    <div className="pulse loading-popup">
      {getLanguageFile("generics.loading")}
    </div>
  );
};
